import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Core } from '@mescius/activereportsjs';
import { CellStyleModule, ClientSideRowModelModule, ColumnApiModule, ColumnAutoSizeModule, CustomEditorModule, CustomFilterModule, GridStateModule, ModuleRegistry as AgGridModuleRegistry, PaginationModule, provideGlobalGridOptions, QuickFilterModule, RowApiModule, RowSelectionModule, TextFilterModule, NumberFilterModule, DateFilterModule, enableDevValidations, RenderApiModule, ClientSideRowModelApiModule } from 'ag-grid-community';
import { LicenseManager as AgGridLicenseManager, CellSelectionModule, ClipboardModule, ColumnsToolPanelModule, MasterDetailModule, MenuModule, MultiFilterModule, SetFilterModule, StatusBarModule, ToolbarModule, TooltipModule, ExternalFilterModule, RowStyleModule } from 'ag-grid-enterprise';
import { LicenseManager as AgChartsLicenseManager, ModuleRegistry as AgChartModuleRegistry, RadialGaugeModule, LinearGaugeModule, } from 'ag-charts-enterprise';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
} else {
  // enable Ag grid development validations - this is equivalent to registering the underlying module (ValidationModule) directly in the ModuleRegistry
  enableDevValidations();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

const agLicenseKey = "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-081800}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Datex_Corp}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Footprint}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Footprint}_need_to_be_licensed___{Footprint}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{22_November_2026}____[v3]_[0102]_MTc5NTMwNTYwMDAwMA==5c8630d2eaf62490960cce0a18d0c413";

AgGridLicenseManager.setLicenseKey(agLicenseKey);
AgChartsLicenseManager.setLicenseKey(agLicenseKey);
// Mark all grids as using legacy themes, see https://www.ag-grid.com/angular-data-grid/errors/239/?_version_=36.0.0
// and https://www.ag-grid.com/angular-data-grid/theming-migration/
provideGlobalGridOptions({ theme: "legacy" });

AgGridModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ClientSideRowModelApiModule,
  MasterDetailModule,
  StatusBarModule,
  MenuModule,
  ColumnsToolPanelModule,
  ColumnAutoSizeModule,
  RowSelectionModule,
  GridStateModule,
  CustomEditorModule,
  CellStyleModule,
  ToolbarModule,
  PaginationModule,
  SetFilterModule,
  MultiFilterModule,
  QuickFilterModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  RowApiModule,
  ColumnApiModule,
  RenderApiModule,
  CellSelectionModule,
  ClipboardModule,
  TooltipModule,
  ExternalFilterModule,
  RowStyleModule
]);

AgChartModuleRegistry.registerModules([
  RadialGaugeModule,
  LinearGaugeModule,
]);

Core.setLicenseKey(environment.mesciusLicenseKey);
